import React from 'react';
import { Box } from '@mui/material';
import { Toaster } from 'react-hot-toast'
import Sidebar from '../Sidebar/Sidebar';
import HamburgerMenu from '../HamburgerMenu';

export const PublicMarketplaceLayout = ({ children }) => {
    return (
        <>
            <HamburgerMenu isPublic={true} />
            <Sidebar isPublic={true} />
            <div id="app-wrapper">
                {children}
            </div>
            <Toaster />
        </>
    );
};